import {createModel} from '@@/package/utils/ModelUtil';
import {LearningTaskModel} from "~~/package/mapper/learning/model/LearningTaskModel";

export class LearningSkillModel {
    constructor(
        public id: number = 0,
        public title: string = "",
        public skillMapUserId: number = 0,
        public skillPoint: number = 0,
        public completeFlag: boolean = false,
        public taskList: LearningTaskModel[] = [],
    ) {}

    public static create(model: Partial<LearningSkillModel>): LearningSkillModel {
        return createModel<LearningSkillModel>(LearningSkillModel, {
            ...model
        });
    }
}
